import axios from 'axios';
import { API_HOST } from '../constants/constants';
export const postOrganizationFaq = async (token, userID, options) => {
  const apiURL = API_HOST + '/organization_faqs';
  
  try {
    const { data } = await axios.post(apiURL,{
      organization_faq:options
    },{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-gg-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
